import { ConfigActionType } from '@/types';
export const configReducer = (state, action) => {
    switch (action.type) {
        case ConfigActionType.SET_APP_CONFIG:
            return Object.assign(Object.assign({}, state), { appConfig: Object.assign(Object.assign({}, state.appConfig), action.payload) });
        default:
            throw new Error();
    }
};
